import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketOverview = () => {
  const marketStats = [
    {
      id: 1,
      title: "Total Market Cap",
      value: "$2.45T",
      change: 2.34,
      icon: "TrendingUp",
      description: "Global cryptocurrency market capitalization"
    },
    {
      id: 2,
      title: "24h Volume",
      value: "$89.2B",
      change: -1.23,
      icon: "BarChart3",
      description: "Total trading volume in last 24 hours"
    },
    {
      id: 3,
      title: "Bitcoin Dominance",
      value: "52.8%",
      change: 0.45,
      icon: "PieChart",
      description: "Bitcoin\'s share of total market cap"
    },
    {
      id: 4,
      title: "Active Cryptocurrencies",
      value: "13,247",
      change: 0.89,
      icon: "Coins",
      description: "Number of active digital currencies"
    }
  ];

  return (
    <div className="bg-card border border-border rounded-brand p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-foreground">Market Overview</h2>
          <p className="text-sm text-muted-foreground">Global cryptocurrency market statistics</p>
        </div>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>Updated: {new Date()?.toLocaleTimeString()}</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {marketStats?.map((stat) => {
          const isPositive = stat?.change >= 0;
          
          return (
            <div key={stat?.id} className="bg-muted/50 rounded-brand-sm p-4 hover:bg-muted/70 transition-brand">
              <div className="flex items-start justify-between mb-3">
                <div className={`w-10 h-10 rounded-brand-sm flex items-center justify-center ${
                  isPositive ? 'bg-success/10' : 'bg-destructive/10'
                }`}>
                  <Icon 
                    name={stat?.icon} 
                    size={20} 
                    className={isPositive ? 'text-success' : 'text-destructive'}
                  />
                </div>
                <div className={`flex items-center space-x-1 text-xs font-medium ${
                  isPositive ? 'text-success' : 'text-destructive'
                }`}>
                  <Icon 
                    name={isPositive ? "ArrowUp" : "ArrowDown"} 
                    size={12} 
                  />
                  <span>{Math.abs(stat?.change)}%</span>
                </div>
              </div>
              <div className="space-y-1">
                <h3 className="text-2xl font-bold text-foreground">{stat?.value}</h3>
                <p className="text-sm font-medium text-foreground">{stat?.title}</p>
                <p className="text-xs text-muted-foreground">{stat?.description}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span className="text-muted-foreground">Fear & Greed Index:</span>
              <span className="font-medium text-success">72 (Greed)</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-primary rounded-full"></div>
              <span className="text-muted-foreground">Market Sentiment:</span>
              <span className="font-medium text-primary">Bullish</span>
            </div>
          </div>
          <div className="text-muted-foreground">
            Next update in 5 minutes
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketOverview;